/* Mummy & Munchkin — product page.
   Gallery + zoom, variant resolution (colour swatches / size boxes / chips), size-required
   error state, sold-out notify, low stock, add to bag + order now,
   sticky bar + compact picker, size chart units, bundle, recently viewed. */
(function () {
  'use strict';
  const root = document.querySelector('[data-mm-product]');
  if (!root) return;
  const MM = (window.MM = window.MM || {});
  const fmt = (c) => (MM.formatMoney ? MM.formatMoney(c) : 'Rs ' + Math.round(c / 100));
  const desktop = () => matchMedia('(min-width: 990px)').matches;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  let variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-mm-variants]').textContent);
  } catch (e) {}

  const d = root.dataset;
  const sizeIdx = parseInt(d.sizeOption, 10);
  const colorIdx = parseInt(d.colorOption, 10);
  const lowAt = parseInt(d.lowStock, 10) || 3;
  const form = root.querySelector('form[data-mm-atc]');
  const idInput = root.querySelector('[data-mm-variant-id]');
  const q = (sel) => root.querySelector(sel);

  /* ---------------- gallery ---------------- */
  const rail = q('[data-mm-gallery-rail]');
  const slides = Array.from(root.querySelectorAll('.mm-pdp__slide'));
  const thumbs = Array.from(root.querySelectorAll('[data-mm-thumb]'));
  const counter = q('[data-mm-counter-current]');
  const shot = q('[data-mm-shot]');
  let currentIndex = 0;

  function paintGallery(i) {
    currentIndex = i;
    slides.forEach((s, j) => s.classList.toggle('is-active', j === i));
    thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
    if (counter) counter.textContent = i + 1;
    if (shot && slides[i]) shot.textContent = slides[i].getAttribute('data-mm-alt') || '';
    const active = thumbs[i];
    active && active.scrollIntoView && active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  }
  function goTo(i, scroll = true) {
    if (i < 0 || i >= slides.length) return;
    paintGallery(i);
    if (!desktop() && scroll && rail) rail.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
  }
  function showMediaId(id) {
    const i = slides.findIndex((s) => s.getAttribute('data-mm-media-id') === String(id));
    if (i >= 0) goTo(i);
  }
  thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
  // desktop arrows (wrap around) + zoom button for the current image
  const prevBtn = q('[data-mm-gallery-prev]');
  const nextBtn = q('[data-mm-gallery-next]');
  const zoomIcon = q('[data-mm-gallery-zoom]');
  const step = (d) => goTo((currentIndex + d + slides.length) % slides.length);
  prevBtn && prevBtn.addEventListener('click', () => step(-1));
  nextBtn && nextBtn.addEventListener('click', () => step(1));
  zoomIcon && zoomIcon.addEventListener('click', () => {
    const b = slides[currentIndex] && slides[currentIndex].querySelector('[data-mm-zoom]');
    b && b.click();
  });
  const stage = q('.mm-pdp__stage');
  stage && stage.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
  });
  if (rail) {
    let t = null;
    rail.addEventListener(
      'scroll',
      () => {
        if (desktop()) return;
        clearTimeout(t);
        t = setTimeout(() => paintGallery(Math.round(rail.scrollLeft / rail.clientWidth)), 80);
      },
      { passive: true }
    );
  }

  /* zoom viewer */
  const zoom = document.getElementById('mm-zoom');
  const zoomStage = zoom && zoom.querySelector('[data-mm-zoom-stage]');
  const zoomSlides = zoom ? Array.from(zoom.querySelectorAll('[data-mm-zoom-index]')) : [];
  const zoomCounter = zoom && zoom.querySelector('[data-mm-zoom-counter]');
  function zoomTo(i) {
    const s = zoomSlides.find((z) => parseInt(z.getAttribute('data-mm-zoom-index'), 10) === i) || zoomSlides[0];
    if (!s) return;
    zoomSlides.forEach((z) => z.classList.toggle('is-active', z === s));
    zoom.querySelectorAll('[data-mm-zoom-go]').forEach((b) => b.classList.toggle('is-active', b.getAttribute('data-mm-zoom-go') === s.getAttribute('data-mm-zoom-index')));
    if (zoomCounter) zoomCounter.textContent = zoomSlides.indexOf(s) + 1 + ' / ' + zoomSlides.length;
    s.classList.remove('is-zoomed');
  }
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mm-zoom]');
    if (!b || !zoom || !zoomSlides.length) return;
    zoomTo(parseInt(b.getAttribute('data-mm-zoom'), 10));
    MM.drawer.open('mm-zoom', b);
  });
  if (zoom) {
    zoom.addEventListener('click', (e) => {
      const go = e.target.closest('[data-mm-zoom-go]');
      if (go) zoomTo(parseInt(go.getAttribute('data-mm-zoom-go'), 10));
    });
    zoom.addEventListener('dblclick', (e) => {
      const s = e.target.closest('.mm-zoom__slide');
      s && s.classList.toggle('is-zoomed');
    });
    let sx = 0;
    zoomStage.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
    zoomStage.addEventListener(
      'touchend',
      (e) => {
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) < 50) return;
        const cur = zoomSlides.findIndex((z) => z.classList.contains('is-active'));
        const next = zoomSlides[cur + (dx < 0 ? 1 : -1)];
        next && zoomTo(parseInt(next.getAttribute('data-mm-zoom-index'), 10));
      },
      { passive: true }
    );
    zoom.addEventListener('keydown', (e) => {
      const cur = zoomSlides.findIndex((z) => z.classList.contains('is-active'));
      if (e.key === 'ArrowRight' && zoomSlides[cur + 1]) zoomTo(parseInt(zoomSlides[cur + 1].getAttribute('data-mm-zoom-index'), 10));
      if (e.key === 'ArrowLeft' && zoomSlides[cur - 1]) zoomTo(parseInt(zoomSlides[cur - 1].getAttribute('data-mm-zoom-index'), 10));
    });
  }

  /* ---------------- variants ---------------- */
  const optionSets = Array.from(root.querySelectorAll('[data-mm-option]'));
  const sizeSet = optionSets.find((s) => parseInt(s.getAttribute('data-mm-option'), 10) === sizeIdx);
  const priceWrap = q('[data-mm-price]');
  const priceNow = q('[data-mm-price-now]');
  const priceWas = q('[data-mm-price-was]');
  const priceSave = q('[data-mm-price-save]');
  const atcBtn = q('[data-mm-atc-btn]');
  const atcLabel = q('[data-mm-atc-label]');
  const atcPrice = q('[data-mm-atc-price]');
  const lowEl = q('[data-mm-low]');
  const sizeErr = q('[data-mm-size-error]');
  const notify = q('[data-mm-notify]');
  const notifySize = q('[data-mm-notify-size]');
  const notifyLink = q('[data-mm-notify-link]');
  const askLink = q('[data-mm-ask]');
  const stickyVariant = q('[data-mm-sticky-variant]');
  const stickyPrice = q('[data-mm-sticky-price]');
  const stickyBtn = q('[data-mm-sticky-btn]');
  const atcDefault = atcLabel ? atcLabel.textContent : 'ADD TO BAG';

  function selected() {
    return optionSets.map((set) => {
      const c = set.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function sizeChosen() {
    return !sizeSet || !!sizeSet.querySelector('input:checked');
  }
  function findVariant(opts) {
    if (opts.some((o) => o === null)) return null;
    return variants.find((v) => v.options.every((o, i) => o === opts[i]));
  }
  // Best variant for pricing when size not yet chosen: first available matching the chosen options.
  function partialVariant(opts) {
    return variants.find((v) => v.available && v.options.every((o, i) => opts[i] === null || o === opts[i])) || variants.find((v) => v.options.every((o, i) => opts[i] === null || o === opts[i])) || variants[0];
  }
  function markAvailability(opts) {
    optionSets.forEach((set, i) => {
      set.querySelectorAll('[data-mm-option-input]').forEach((input) => {
        const probe = opts.slice();
        probe[i] = input.value;
        const match = variants.find((v) => v.options.every((o, j) => probe[j] === null || o === probe[j]));
        const anyAvail = variants.some((v) => v.available && v.options.every((o, j) => (j === i ? o === probe[j] : probe[j] === null || o === probe[j])));
        const label = input.nextElementSibling;
        if (!label) return;
        label.classList.toggle('is-soldout', !!match && !anyAvail);
        label.classList.toggle('is-missing', !match);
        input.setAttribute('aria-label', input.value + (!anyAvail ? ', sold out' : ''));
      });
    });
  }
  /* ---------------- Order on WhatsApp: prefilled message from the current selection ---------------- */
  function buildWaOrder(v, opts) {
    const names = Array.from(root.querySelectorAll('[data-mm-option]')).map((f) => {
      const b = f.querySelector('.mm-pdp__option-label b');
      return b ? b.textContent.replace(/:\s*$/, '').trim() : '';
    });
    const optionLines = names
      .map((name, i) => (name ? '- ' + name + ': ' + (opts && opts[i] ? opts[i] : 'not selected (please suggest)') : ''))
      .filter(Boolean)
      .join('\n');
    const qtyInput = form && form.querySelector('[name="quantity"]');
    const qty = qtyInput && parseInt(qtyInput.value, 10) > 0 ? parseInt(qtyInput.value, 10) : 1;
    const price = v ? fmt(v.price) : '';
    const url = d.productUrl + (v ? '?variant=' + v.id : '');
    const sku = v && v.sku ? ' (' + v.sku + ')' : '';
    const template = d.waMessage || 'Hello [shop]!\nI want to order this:\n\nProduct: [product]\n[options]\nPrice: [price]\nQty: [qty]\nLink: [url]\n\nPayment: Cash on Delivery';
    return template
      .replace(/\[shop\]/g, d.shopName || '')
      .replace(/\[product\]/g, d.productTitle + sku)
      .replace(/\[options\]/g, optionLines)
      .replace(/\[price\]/g, price)
      .replace(/\[qty\]/g, String(qty))
      .replace(/\[url\]/g, url)
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function paintPrice(v) {
    if (!v) return;
    const sale = v.compare_at_price && v.compare_at_price > v.price;
    if (priceNow) priceNow.textContent = fmt(v.price);
    if (priceWas) {
      priceWas.textContent = sale ? fmt(v.compare_at_price) : '';
      priceWas.toggleAttribute('hidden', !sale);
    }
    if (priceSave) {
      priceSave.textContent = sale ? 'You save ' + fmt(v.compare_at_price - v.price) + ' (' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%)' : '';
      priceSave.toggleAttribute('hidden', !sale);
    }
    priceWrap && priceWrap.classList.toggle('is-sale', !!sale);
    if (atcPrice) atcPrice.textContent = ' · ' + fmt(v.price);
    if (stickyPrice) {
      stickyPrice.textContent = fmt(v.price);
      stickyPrice.classList.toggle('is-sale', !!sale);
    }
  }
  function variantLabel(opts) {
    const parts = opts.map((o, i) => (i === sizeIdx && !o ? 'No ' + (d.sizeLabel || 'size').toLowerCase() : o)).filter(Boolean);
    return parts.join(' · ');
  }
  function applyState() {
    const opts = selected();
    markAvailability(opts);
    const chosen = sizeChosen();
    const v = chosen ? findVariant(opts) : partialVariant(opts);
    paintPrice(v);
    if (stickyVariant) stickyVariant.textContent = variantLabel(opts);
    if (chosen && v) {
      if (idInput) idInput.value = v.id;
      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? atcDefault : 'Sold Out';
      if (stickyBtn) {
        stickyBtn.textContent = v.available ? atcDefault : 'Sold Out';
        stickyBtn.disabled = !v.available;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      if (v.featured_media && v.featured_media.id) showMediaId(v.featured_media.id);
      // low stock
      const managed = v.inventory_management === 'shopify';
      const qty = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null;
      if (lowEl) {
        const low = managed && qty !== null && qty > 0 && qty <= lowAt;
        lowEl.textContent = low ? 'Only ' + qty + ' left' + (opts[sizeIdx] ? ' in ' + opts[sizeIdx] : '') : '';
        lowEl.toggleAttribute('hidden', !low);
      }
    } else {
      if (atcBtn) atcBtn.disabled = false;
      if (atcLabel) atcLabel.textContent = atcDefault;
      if (stickyBtn) {
        stickyBtn.textContent = d.sizeLabel ? 'Select ' + d.sizeLabel : 'Select Size';
        stickyBtn.disabled = false;
      }
      lowEl && lowEl.setAttribute('hidden', '');
    }
    if (askLink) askLink.href = 'https://wa.me/' + d.whatsapp + '?text=' + encodeURIComponent(buildWaOrder(v, opts));
    syncCompact();
  }

  root.addEventListener('change', (e) => {
    const input = e.target.closest('[data-mm-option-input]');
    if (!input) return;
    const set = input.closest('[data-mm-option]');
    const valueEl = set.querySelector('[data-mm-option-value]');
    if (valueEl) valueEl.textContent = input.value;
    if (set === sizeSet) {
      sizeErr && sizeErr.setAttribute('hidden', '');
      sizeSet.classList.remove('has-error');
      // sold-out size tapped → notify box
      const label = input.nextElementSibling;
      const out = label && label.classList.contains('is-soldout');
      if (notify) {
        notify.toggleAttribute('hidden', !out);
        if (out) {
          notifySize.textContent = input.value;
          if (notifyLink) notifyLink.href = 'https://wa.me/' + d.whatsapp + '?text=' + encodeURIComponent('Hi! Please notify me when ' + d.productTitle + ' is back in ' + input.value + '. ' + d.productUrl);
        }
      }
    }
    applyState();
  });

  function requireSize() {
    if (sizeChosen()) return true;
    if (sizeSet) {
      sizeSet.classList.remove('has-error');
      void sizeSet.offsetWidth;
      sizeSet.classList.add('has-error');
      sizeErr && sizeErr.removeAttribute('hidden');
      sizeSet.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
    return false;
  }

  if (form) {
    form.addEventListener(
      'submit',
      (e) => {
        if (!requireSize()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
    form.addEventListener('mm:atc:success', () => {
      const added = q('[data-mm-added]');
      added && added.removeAttribute('hidden');
      if (atcLabel) {
        atcLabel.textContent = 'Added to Bag ✓';
        setTimeout(() => (atcLabel.textContent = atcDefault), 2000);
      }
    });
  }

  // Order now — COD: add silently then go straight to checkout
  root.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-mm-order-now]');
    if (!b) return;
    if (!requireSize()) return;
    const id = Number(idInput && idInput.value);
    if (!id) return;
    b.setAttribute('aria-busy', 'true');
    try {
      await MM.cart.add([{ id, quantity: 1 }], { silent: true });
      window.location.href = '/checkout';
    } catch (err) {
      b.removeAttribute('aria-busy');
      const msg = q('[data-mm-atc-error]');
      if (msg) {
        msg.textContent = (err && (err.description || err.message)) || 'Could not add to bag.';
        msg.removeAttribute('hidden');
      }
    }
  });

  /* ---------------- sticky bar + compact picker ---------------- */
  const sticky = q('[data-mm-sticky]');
  const compact = document.getElementById('mm-compact-size');
  const compactValues = compact && compact.querySelector('[data-mm-compact-values]');
  const compactAdd = compact && compact.querySelector('[data-mm-compact-add]');
  function syncCompact() {
    if (!compactValues || !sizeSet) return;
    const chosen = sizeSet.querySelector('input:checked');
    compactValues.innerHTML = '';
    sizeSet.querySelectorAll('[data-mm-option-input]').forEach((input) => {
      const src = input.nextElementSibling;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'mm-pdp__value' + (src.classList.contains('is-soldout') ? ' is-soldout' : '') + (input.checked ? ' is-on' : '');
      b.textContent = input.value;
      b.addEventListener('click', () => {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      compactValues.appendChild(b);
    });
    if (compactAdd) {
      const v = chosen ? findVariant(selected()) : null;
      compactAdd.textContent = chosen ? 'Add ' + chosen.value + ' to Bag · ' + fmt(v ? v.price : 0) : (d.sizeLabel ? 'Select ' + d.sizeLabel + ' above' : 'Select a size above');
      compactAdd.disabled = !chosen || !(v && v.available);
    }
  }
  compactAdd &&
    compactAdd.addEventListener('click', () => {
      MM.drawer.close('mm-compact-size');
      form && form.requestSubmit();
    });
  stickyBtn &&
    stickyBtn.addEventListener('click', () => {
      if (!sizeChosen() && compact) {
        syncCompact();
        MM.drawer.open('mm-compact-size', stickyBtn);
        return;
      }
      form && form.requestSubmit();
    });
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    sticky.removeAttribute('hidden');
    let atcOff = false;
    let footerOn = false;
    const paint = () => sticky.toggleAttribute('data-visible', atcOff && !footerOn && !desktop());
    new IntersectionObserver((en) => {
      atcOff = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      paint();
    }).observe(atcBtn);
    const footer = document.querySelector('.mm-footer');
    footer &&
      new IntersectionObserver((en) => {
        footerOn = en[0].isIntersecting;
        paint();
      }).observe(footer);
  }

  /* ---------------- Order on WhatsApp: always filled, rebuilt on click ---------------- */
  function syncWaLink() {
    if (!askLink || !d.whatsapp) return;
    const opts = optionSets.length ? selected() : [];
    const v = (optionSets.length ? findVariant(opts) : null) || variants.find((x) => x.available) || variants[0] || null;
    askLink.href = 'https://wa.me/' + d.whatsapp + '?text=' + encodeURIComponent(buildWaOrder(v, opts));
  }
  syncWaLink();
  if (askLink) askLink.addEventListener('click', syncWaLink);

  /* ---------------- size chart units ---------------- */
  const chart = document.querySelector('[data-mm-size-chart]');
  const unitsWrap = document.querySelector('[data-mm-units]');
  if (chart && unitsWrap) {
    chart.querySelectorAll('td, th').forEach((cell) => {
      if (cell.cellIndex === 0) return;
      cell.dataset.cm = cell.textContent;
    });
    unitsWrap.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mm-unit]');
      if (!b) return;
      const unit = b.getAttribute('data-mm-unit');
      unitsWrap.querySelectorAll('[data-mm-unit]').forEach((x) => x.classList.toggle('mm-chip--active', x === b));
      chart.querySelectorAll('td, th').forEach((cell) => {
        if (cell.cellIndex === 0 || cell.dataset.cm === undefined) return;
        const base = cell.dataset.cm;
        cell.textContent = unit === 'cm' ? base : base.replace(/\d+(\.\d+)?/g, (n) => (parseFloat(n) / 2.54).toFixed(1)).replace(/\bcm\b/g, 'in');
      });
    });
  }

  /* ---------------- recently viewed ---------------- */
  try {
    const KEY = 'mm-recent';
    let list = JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => h !== d.productHandle);
    list.unshift(d.productHandle);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
  } catch (e) {}

  /* ---------------- init ---------------- */
  if (optionSets.length) applyState();
  else paintPrice(variants[0]);
})();

/* ---------------- bundle (separate section, same page) ---------------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-mm-bundle]').forEach((wrap) => {
    const MM = window.MM || {};
    const fmt = (c) => (MM.formatMoney ? MM.formatMoney(c) : 'Rs ' + Math.round(c / 100));
    const saving = parseInt(wrap.getAttribute('data-saving'), 10) || 0;
    const items = Array.from(wrap.querySelectorAll('[data-mm-bundle-item]'));
    const sumEl = wrap.querySelector('[data-mm-bundle-sum]');
    const totalEl = wrap.querySelector('[data-mm-bundle-total]');
    const saveEl = wrap.querySelector('[data-mm-bundle-save]');
    const addBtn = wrap.querySelector('[data-mm-bundle-add]');
    const price = (it) => {
      const sel = it.querySelector('select');
      return parseInt(sel ? sel.selectedOptions[0].getAttribute('data-price') : it.getAttribute('data-price'), 10) || 0;
    };
    const paint = () => {
      const on = items.filter((it) => it.querySelector('[data-mm-bundle-check]').getAttribute('aria-checked') === 'true');
      const all = on.length === items.length && items.length > 0;
      const sum = on.reduce((a, it) => a + price(it), 0);
      if (sumEl) {
        sumEl.textContent = fmt(sum);
        sumEl.toggleAttribute('hidden', !all || !saving);
      }
      if (totalEl) totalEl.textContent = fmt(all ? sum - saving : sum);
      if (saveEl) saveEl.textContent = saving ? (all ? 'You save ' + fmt(saving) + ' buying together' : 'Tick all ' + items.length + ' to save ' + fmt(saving)) : '';
      if (addBtn) addBtn.disabled = on.length === 0;
    };
    wrap.addEventListener('click', (e) => {
      const c = e.target.closest('[data-mm-bundle-check]');
      if (!c) return;
      c.setAttribute('aria-checked', c.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      paint();
    });
    wrap.addEventListener('change', paint);
    addBtn &&
      addBtn.addEventListener('click', async () => {
        const lines = items
          .filter((it) => it.querySelector('[data-mm-bundle-check]').getAttribute('aria-checked') === 'true')
          .map((it) => {
            const sel = it.querySelector('select');
            return { id: parseInt(sel ? sel.value : it.getAttribute('data-variant'), 10), quantity: 1 };
          })
          .filter((l) => l.id);
        if (!lines.length) return;
        addBtn.setAttribute('aria-busy', 'true');
        try {
          await MM.cart.add(lines);
        } finally {
          addBtn.removeAttribute('aria-busy');
        }
      });
    paint();
  });
})();
